import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

// URL del CMS Keystone
const CMS_URL = 'https://voy-abm-cms-f19b6a201fa4.herokuapp.com/api/graphql';

// Crear el link HTTP
const httpLink = createHttpLink({
  uri: CMS_URL,
});

// Link para agregar headers de autenticación si es necesario
const authLink = setContext((_, { headers }) => {
  // Por ahora no necesitamos autenticación para consultas públicas
  // Si necesitas autenticación, puedes agregar el token aquí
  // const token = localStorage.getItem('authToken');
  
  return {
    headers: {
      ...headers,
      'Content-Type': 'application/json',
      // 'Authorization': token ? `Bearer ${token}` : '',
    }
  }
});

// Crear el cliente Apollo
export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
  },
  // Configuración para desarrollo
  connectToDevTools: false, // Desactiva la conexión automática a DevTools
}); 